import { storyApi } from 'client/store/story/storyApi'

export const useGetStory = storyApi.endpoints.getStory.useQuery
